function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "../../node_modules/react-i18nify/build/lib recursive";


//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/react-i18nify/build/lib
// module id = ../../node_modules/react-i18nify/build/lib recursive
// module chunks = widget-6.25.3